module.exports = __webpack_public_path__ + "img/blockage.f9dc7816.svg";